import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';

import { buttonVariants, cn } from '@cold-ambulance/shadcn';
import { SuccessIcon } from '@cold-ambulance/ui';

export default function OfferPlaced() {
  const { t } = useTranslation();

  return (
    <div className="page-container">
      <div className="mx-auto flex min-h-0 max-w-xs flex-1 flex-col justify-center">
        <div className="flex flex-col items-center justify-center gap-y-6">
          <SuccessIcon />
          <p className="text-3xl font-semibold">{t('offers.successTitle')}</p>
        </div>
        <p className="mt-4 text-center">
          {t('offers.successMessage')}{' '}
        </p>
        <Link
          to="/"
          className={buttonVariants({
            variant: 'default',
            className: 'mt-20 !h-11 px-6',
          })}
        >
          {t('offers.goToDashboard')}
        </Link>
        <div className="mb-4"></div>
        <Link
          to="/requests"
          className={buttonVariants({
            variant: 'outline',
            className: cn('!h-11 px-6', 'text-primary bg-transparent'),
          })}
        >
          {t('offers.viewOtherRequests')}
        </Link>
      </div>
    </div>
  );
}
